function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/operation/markeroperation
 */
import Operation from './operation';
import Range from '../range';
/**
 * @extends module:engine/model/operation/operation~Operation
 */

var MarkerOperation = /*#__PURE__*/function (_Operation) {
  _inherits(MarkerOperation, _Operation);

  var _super = _createSuper(MarkerOperation);

  /**
   * @param {String} name Marker name.
   * @param {module:engine/model/range~Range} oldRange Marker range before the change.
   * @param {module:engine/model/range~Range} newRange Marker range after the change.
   * @param {module:engine/model/markercollection~MarkerCollection} markers Marker collection on which change should be executed.
   * @param {Boolean} affectsData Specifies whether the marker operation affects the data produced by the data pipeline
   * (is persisted in the editor's data).
   * @param {Number|null} baseVersion Document {@link module:engine/model/document~Document#version} on which operation
   * can be applied or `null` if the operation operates on detached (non-document) tree.
   */
  function MarkerOperation(name, oldRange, newRange, markers, affectsData, baseVersion) {
    var _this;

    _classCallCheck(this, MarkerOperation);

    _this = _super.call(this, baseVersion);
    /**
     * Marker name.
     *
     * @readonly
     * @member {String}
     */

    _this.name = name;
    /**
     * Marker range before the change.
     *
     * @readonly
     * @member {module:engine/model/range~Range}
     */

    _this.oldRange = oldRange ? oldRange.clone() : null;
    /**
     * Marker range after the change.
     *
     * @readonly
     * @member {module:engine/model/range~Range}
     */

    _this.newRange = newRange ? newRange.clone() : null;
    /**
     * Specifies whether the marker operation affects the data produced by the data pipeline
     * (is persisted in the editor's data).
     *
     * @readonly
     * @member {Boolean}
     */

    _this.affectsData = affectsData;
    /**
     * Marker collection on which change should be executed.
     *
     * @private
     * @member {module:engine/model/markercollection~MarkerCollection}
     */

    _this._markers = markers;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MarkerOperation, [{
    key: "type",
    get: function get() {
      return 'marker';
    }
    /**
     * Creates and returns an operation that has the same parameters as this operation.
     *
     * @returns {module:engine/model/operation/markeroperation~MarkerOperation} Clone of this operation.
     */

  }, {
    key: "clone",
    value: function clone() {
      return new MarkerOperation(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     *
     * @returns {module:engine/model/operation/markeroperation~MarkerOperation}
     */

  }, {
    key: "getReversed",
    value: function getReversed() {
      return new MarkerOperation(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_execute",
    value: function _execute() {
      var type = this.newRange ? '_set' : '_remove';

      this._markers[type](this.name, this.newRange, true, this.affectsData);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _get(_getPrototypeOf(MarkerOperation.prototype), "toJSON", this).call(this);

      if (this.oldRange) {
        json.oldRange = this.oldRange.toJSON();
      }

      if (this.newRange) {
        json.newRange = this.newRange.toJSON();
      }

      delete json._markers;
      return json;
    }
    /**
     * @inheritDoc
     */

  }], [{
    key: "className",
    get: function get() {
      return 'MarkerOperation';
    }
    /**
     * Creates `MarkerOperation` object from deserialized object, i.e. from parsed JSON string.
     *
     * @param {Object} json Deserialized JSON object.
     * @param {module:engine/model/document~Document} document Document on which this operation will be applied.
     * @returns {module:engine/model/operation/markeroperation~MarkerOperation}
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json, document) {
      return new MarkerOperation(json.name, json.oldRange ? Range.fromJSON(json.oldRange, document) : null, json.newRange ? Range.fromJSON(json.newRange, document) : null, document.model.markers, json.affectsData, json.baseVersion);
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return `MarkerOperation( ${ this.baseVersion } ): ` +
    // @if CK_DEBUG_ENGINE //		`"${ this.name }": ${ this.oldRange } -> ${ this.newRange }`;
    // @if CK_DEBUG_ENGINE // }

  }]);

  return MarkerOperation;
}(Operation);

export { MarkerOperation as default };